// extracted by mini-css-extract-plugin
export var bodySections = "_e6-8";
export var gray = "_e6-7";
export var green = "_e6-4";
export var iconContainer = "_e6-9";
export var iconWidgetContainer = "_e6-1";
export var phoneIcon = "_e6-2";
export var red = "_e6-5";
export var statusDot = "_e6-3";
export var widgetContainer = "_e6-0";
export var yellow = "_e6-6";